import { Dispatch } from 'redux'
import { connect } from 'react-redux'

import ProductItemControls, { IStateProps, IDispatchProps, IOwnProps } from './ProductItemControls'
import { DashboardAction, requestPrint, requestProductAccept, resetFailedOrderId } from '../../services/store/actions/dashboard/DashboardAction'

import  { IStoreState } from '../../services/store/IStoreState'
import FailedOrderReason from '../../constants/FailedOrderReason'

function mapStateToProps(state: IStoreState): IStateProps {
  return {
    notPreparedOrderId: state.Dashboard.failedOrder?.reason === FailedOrderReason.NOT_ALL_PRODUCTS_PREPARED
      ? state.Dashboard.failedOrder.orderId : undefined,
  }
}

function mapDispatchToProps(dispatch: Dispatch<DashboardAction>): IDispatchProps {
  return {
    requestProductAccept: (product) => dispatch(requestProductAccept({product})),
    requestPrint: (product) => dispatch(requestPrint({product})),
    resetFailedOrderId: () => dispatch(resetFailedOrderId()),
  }
}

export default connect<IStateProps, IDispatchProps, IOwnProps, IStoreState>(
  mapStateToProps,
  mapDispatchToProps
)(ProductItemControls)
